export enum Image {
    HEROBANNER = '/images/herobanner_gradient.jpg',
    HEROBANNER_MOBILE = '/images/about_me_3.jpg',
    LOGO = '/images/logo_agata_sawicka_black.png',
    LOGO_BLACK = '/images/logo_agata_sawicka_black.png',
    LOGO_WHITE = '/images/logo_agata_sawicka_white.png',
    BOOKSY_LOGO = '/images/booksy_logo.png',
    BOOKSY_SHORT_LOGO = '/images/booksy_short_logo.svg',
    BOOKSY_SHORT_LOGO_WHITE = '/images/booksy_short_logo_white.svg',
    BOOKSY_SHORT_LOGO_BROWN = '/images/booksy_short_logo_brown.svg',
    GOOGLE_LOGO = '/images/google_g_logo.png',
    ABOUT_ME = '/images/about_me.jpg',
    ABOUT_ME_1 = '/images/about_me_1.jpg',
    ABOUT_ME_2 = '/images/about_me_2.jpg',
    ABOUT_ME_3 = '/images/about_me_3.jpg',
    ABOUT_ME_4 = '/images/about_me_4.jpg',
    ABOUT_ME_5 = '/images/about_me_5.jpg',
    STUDIO_SMALLER = '/images/studio_smaller.jpg',
    STUDIO_REVIEWS_MOBILE = '/images/studio_reviews_mobile_2.jpg',
    STUDIO_TILES = '/images/studio_image.jpg',
    PORTFOLIO_1 = '/images/portfolio_1.jpg',
    PORTFOLIO_2 = '/images/portfolio_3.jpg',
    PORTFOLIO_3 = '/images/portfolio_5.jpeg',
    PORTFOLIO_4 = '/images/portfolio_22.jpg',
    PORTFOLIO_5 = '/images/portfolio_4.jpg',
    PORTFOLIO_7 = '/images/portfolio_6.jpg',
    PORTFOLIO_6 = '/images/portfolio_7.jpeg',
    VOUCHER_1 = '/images/voucher_1.jpg',
    VOUCHER_2 = '/images/voucher_2.jpg',
    CONTACT_FORM_BACKGROUND = '/images/studio_image.jpg',
    GOOGLE_MAPS_LINK = '/images/google_map.png',
    JUST_PAMPAS = '/images/just_pampas.jpg'
}